import type { SectionControlsProps } from "../../types/caseView";
import { ALL_SECTION_KEYS } from "../../utils/caseViewHelpers";

export function SectionControls({
  expandedSections,
  onExpandAll,
  onCollapseAll,
  onReset,
  callMode,
}: SectionControlsProps) {
  const allExpanded = expandedSections.size === ALL_SECTION_KEYS.length;
  const allCollapsed = expandedSections.size === 0;
  
  return (
    <div className={`flex items-center gap-2 text-xs ${
      callMode ? "text-slate-500" : "text-slate-400"
    }`}>
      <button
        onClick={onExpandAll}
        disabled={allExpanded}
        className={`px-2 py-1 rounded transition-colors ${
          allExpanded
            ? "opacity-40 cursor-not-allowed"
            : callMode
              ? "hover:bg-slate-700 hover:text-slate-300"
              : "hover:bg-slate-100 hover:text-slate-600"
        }`}
      >
        Expand all
      </button>
      <span className="opacity-30">|</span>
      <button
        onClick={onCollapseAll}
        disabled={allCollapsed}
        className={`px-2 py-1 rounded transition-colors ${
          allCollapsed
            ? "opacity-40 cursor-not-allowed"
            : callMode
              ? "hover:bg-slate-700 hover:text-slate-300"
              : "hover:bg-slate-100 hover:text-slate-600"
        }`}
      >
        Collapse all
      </button>
      <span className="opacity-30">|</span>
      <button
        onClick={onReset}
        className={`px-2 py-1 rounded transition-colors ${
          callMode
            ? "hover:bg-slate-700 hover:text-slate-300"
            : "hover:bg-slate-100 hover:text-slate-600"
        }`}
      >
        Reset
      </button>
    </div>
  );
}